
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/context/language-context';

interface SeedphraseDisplayProps {
  seedPhrase: string;
  onContinue: () => void;
}

export const SeedphraseDisplay: React.FC<SeedphraseDisplayProps> = ({ 
  seedPhrase,
  onContinue
}) => {
  const { t } = useLanguage();
  
  return (
    <div className="space-y-4">
      <Alert>
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>{t('Your seedphrase has been created')}</AlertTitle>
        <AlertDescription className="mt-2">
          <div className="p-3 bg-muted rounded-md font-mono text-sm overflow-x-auto">
            {seedPhrase}
          </div>
        </AlertDescription>
      </Alert>
      
      <Button 
        onClick={onContinue}
        className="w-full bg-pink-gradient hover:opacity-90 mt-4"
      >
        {t('Continue to Dashboard')}
      </Button>
      
      <p className="text-center text-sm text-muted-foreground mt-4">
        {t('Already have an account?')}{' '}
        <Link to="/login" className="text-primary hover:underline font-medium">
          {t('Sign in')}
        </Link>
      </p>
    </div>
  );
};
